import * as THREE from 'three';
import { EditType, SetScaleObjectType } from '../../types';
import BasicObject from '../BasicObject';
import { EventUpdateSizeScale, EventUpdateSizeScaleType } from '../../../helpers/events';
import { CircleCrossMove } from './CircleCrossMove';
import { LineScale } from './LineScale';

interface ConstructorScaleProps {
  edit: EditType;
}
export class SetScaleObject extends THREE.Group implements SetScaleObjectType {
  private posY = 5;
  private currentPos = new THREE.Vector3();
  private startMoveObject: PointMove | null = null;
  private endMoveObject: PointMove | null = null;
  private lineObject: LineScale | null = null;
  private edit: EditType;

  constructor({ edit }: ConstructorScaleProps) {
    super();
    this.name = 'set_scale_group';
    this.edit = edit;

    this.buildGroup();
  }

  buildGroup() {
    const p1 = new THREE.Vector3(-1, this.posY, 0);
    const p2 = new THREE.Vector3(1, this.posY, 0);
    const line = new LineScale({
      startPoint: p1,
      endPoint: p2,
    });
    const circle1 = new CircleCrossMove();
    circle1.position.copy(p1);
    const circle2 = new CircleCrossMove();
    circle2.position.copy(p2);

    this.lineObject = line;
    this.startMoveObject = new PointMove({
      position: p1,
      lineObject: line,
      linePosition: 0,
      moveObject: circle1,
    });
    this.endMoveObject = new PointMove({
      position: p2,
      lineObject: line,
      linePosition: 1,
      moveObject: circle2,
    });

    this.add(this.startMoveObject, this.endMoveObject, line, circle1, circle2);
    this.edit?.dragObject?.addObjectMove(this.startMoveObject);
    this.edit?.dragObject?.addObjectMove(this.endMoveObject);
  }
  updateSizeLine() {
    const dist = this.startMoveObject?.position.distanceTo(
      this.endMoveObject?.position || this.currentPos
    );
    document.dispatchEvent(
      new CustomEvent<EventUpdateSizeScaleType>(EventUpdateSizeScale, {
        detail: { size: dist || 0 },
      })
    );
    return 0;
  }

  removeGroup() {
    this.edit.dragObject?.removeObjectMove(this.startMoveObject?.uuid || '');
    this.edit.dragObject?.removeObjectMove(this.endMoveObject?.uuid || '');
    this.startMoveObject = null;
    this.endMoveObject = null;
    this.lineObject = null;
    while (this.children.length > 0) {
      (this.children[0] as LineScale).removeMesh();
    }

    this.parent?.remove(this);
  }
}

interface PointPropsType {
  linePosition: number;
  lineObject: LineScale;
  position: THREE.Vector3;
  moveObject?: THREE.Mesh;
}
class PointMove extends BasicObject {
  private startPosition = new THREE.Vector3();
  private lineObject;
  moveObject?: THREE.Mesh;
  material = new THREE.MeshBasicMaterial({ color: '#ff00ff', transparent: true, opacity: 0 });
  linePosition;

  constructor({ position, moveObject, linePosition, lineObject }: PointPropsType) {
    super();
    this.name = 'point_funnel_move';
    this.position.copy(position);
    this.moveObject = moveObject;
    this.linePosition = linePosition;
    this.lineObject = lineObject;

    this.buildGeometry();
  }
  buildGeometry() {
    super.buildGeometry();
    this.geometry = new THREE.PlaneGeometry(0.3, 0.3);
    this.geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
  }
  dragStart() {
    this.startPosition.copy(this.position);
  }
  drag() {
    this.lineObject.updateLine(this.linePosition, this.position);
    this?.moveObject?.position.copy(this.position);
    (this.parent as SetScaleObjectType).updateSizeLine();
  }
  dragEnd() {
    super.dragEnd();
  }
  removeMesh() {
    super.removeMesh(this);
  }
}
